<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      app v-if="auth"
      class="elevation-24"
      fixed
    >

      <v-list class="pa-0 ma-0 drawer-box " dense>
        <v-list class="drawer-title-box secondary">
          <v-layout row align-center justify-center class="py-3">
            <img width="90%" src="@/assets/logo.png">
          </v-layout>
        </v-list>
        <v-divider></v-divider>
        <v-list dense>

          <v-list-tile class="mt-2 pa-2" avatar style="cursor:pointer" @click="goProfilo">
            <v-layout row wrap align-center justify-space-between>

              <v-flex xs6 class="text-xs-left ">
                <span class="d-block title font-weight-light">Benvenuto,</span>
                <span class="display-1 mt-3"><b>{{ username }}</b></span>
              </v-flex>

              <v-flex xs6 class="text-xs-right">
                <v-avatar color="success">
                  <span class="white--text display-1">{{ username.substring(0, 1) }}</span>
                </v-avatar>
              </v-flex>

            </v-layout>
          </v-list-tile>

          <v-divider class="mt-2"></v-divider>

          <div class="ma-0 pa-0" v-for="item in menuItems"
               v-if=" ((auth === item.auth) || item.always ) && ( item.position === 'left' || item.position === 'all' ) ">

            <v-list-tile :key="item.title" :to="item.path" v-if="!item.children" class="pa-1">
              <v-list-tile-action>
                <v-icon color="black">{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>{{ item.title }}</v-list-tile-content>
            </v-list-tile>

            <v-list-group
              v-else-if="item.children.length > 0"
              :prepend-icon="item.icon"
              class="pa-2"
            >
              <v-list-tile slot="activator">
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile>

              <v-list-tile class="pl-4" v-for="child in item.children " :to="child.path" :key="child.title"
                           v-if=" ((auth === child.auth) || child.always ) && ( child.position === 'left' || child.position === 'all' )  ">
                <v-list-tile-action class="pa-2">
                  <v-icon v-text="child.icon"></v-icon>
                </v-list-tile-action>
                <v-list-tile-title v-text="child.title"></v-list-tile-title>
              </v-list-tile>
            </v-list-group>
          </div>
        </v-list>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar class="primary py-1" fixed app dense height="30px">
      <v-toolbar-side-icon @click.stop="drawer = !drawer" v-if="auth" class="white--text"></v-toolbar-side-icon>
      <v-toolbar-title class="white--text">
        {{ menuTitle }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn
          flat
          class="white--text"
          v-for="item in menuItems"
          :key="item.title"
          :to="item.path"
          v-if="((auth === item.auth) || item.always ) && ( item.position === 'head' || item.position === 'all' ) ">
          <v-icon left dark>{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-btn>
        <v-btn flat @click="onLogout" v-if="auth" class="white--text">
          <v-icon left dark>eject</v-icon>
          logout
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-content>

      <v-container v-if="!auth" class="DomContainer" fill-height>
        <router-view></router-view>
      </v-container>
      <v-container v-else-if="$route.path.includes('CaricaBolla')" class="pa-3 ma-auto" fill-height>
        <router-view></router-view>
      </v-container>
      <v-container v-else class="DomContainer pt-1 mt-1 ">
        <router-view></router-view>
      </v-container>
    </v-content>

    <v-footer class="primary" app v-if="thereIsFooter()">
      <v-layout row justify-space-between class="mr-3 pl-2 white--text">
        <v-flex class="text-xs-left">
          <span>{{ appTitle }} </span>
        </v-flex>
        <v-flex class="text-xs-right">
          <span>&copy; 2019 - Developed by E-mind srl </span>
        </v-flex>
      </v-layout>
    </v-footer>

  </v-app>
</template>

<script>
/**
 *  posizioni del menu
 *
 *  head
 *  left
 *  foot
 *
 *  all
 */
import GestAxios from './axios-auth'

export default {
  mounted: function () {
    let vm = this
    setInterval(function () {
      if (vm.auth) {
        GestAxios.defaults.headers.common['Authorization'] = 'JWT ' + vm.$store.getters.getMyToken
        GestAxios.get('/isAuthenticate/')
          .then(res => {
            if (res.data.esito == 0) {
              vm.onLogout()
            }
          })
          .catch(error => {
            vm.onLogout()
          })
      }
    }, 10000)
  },
  data () {
    return {
      drawer: null,
      appTitle: 'Gestionale Erboristeria',
      sidebar: false,
      menuItems: [
        {title: 'Dashboard', path: '/', icon: 'fa-house-chimney', auth: true, always: false, position: 'left'},
        {
          title: 'Magazzini',
          path: '/Stores',
          icon: 'fa-store',
          auth: true,
          always: false,
          position: 'left',
          children: [
            {title: 'Elenco', path: '/Stores', icon: 'fa-store', auth: true, always: false, position: 'left'},
            {title: 'Carico', path: '/carico_magazzino', icon: 'fa-barcode', auth: true, always: false, position: 'left'},
            {
              title: 'Trasferimento Giacenze',
              path: '/TrasfGiacMag',
              icon: 'fa-exchange-alt',
              auth: true,
              always: false,
              position: 'left'
            }
          ]
        },
        {
          title: 'Catalogo',
          path: '/Prodotti',
          icon: 'fa-boxes',
          auth: true,
          always: false,
          position: 'left',
          children:
          [
              {title: 'Prodotti', path: '/Prodotti/', icon: 'fa-leaf', auth: true, always: false, position: 'left'},
              {title: 'Categorie', path: '/Categorie/0', icon: 'fa-tree', auth: true, always: false, position: 'left'},
              {title: 'Marche', path: '/Marche', icon: 'local_play', auth: true, always: false, position: 'left'},
              {title: 'Linee', path: '/Linee', icon: 'grade', auth: true, always: false, position: 'left'},
            {
              title: 'Modifiche massive',
              path: '/ModProd',
              icon: 'fa-pencil-alt',
              auth: true,
              always: false,
              position: 'left'
            }
          ]
        },
        {
          title: 'Fornitori',
          path: '/Fornitori',
          icon: 'local_shipping',
          auth: true,
          always: false,
          position: 'left',
          children:
          [
            {
              title: 'Fornitori',
              path: '/Fornitori',
              icon: 'fa-people-carry',
              auth: true,
              always: false,
              position: 'left'
            },
            {
              title: 'Ordini Fornitori',
              path: '/OrdiniFornitori',
              icon: 'fa-box',
              auth: true,
              always: false,
              position: 'left'
            },
            {
              title: 'Carica Bolla',
              path: '/CaricaBolla',
              icon: 'fa-box-open',
              auth: true,
              always: false,
              position: 'left'
            },
            {
              title: 'Prodotti da Ordinare',
              path: '/ProdottiDaOrdinare',
              icon: 'fa-th',
              auth: true,
              always: false,
              position: 'left'
            }
          ]
        },
        {title: 'Movimenti', path: '/Movimenti', icon: 'fa-chart-line', auth: true, always: false, position: 'left'},
        {
          title: 'Ordini Clienti',
          path: '/ordini_clienti',
          icon: 'fa-cart-arrow-down',
          auth: true,
          always: false,
          position: 'left'
        },
        {title: 'Inventario', path: '/InventarioGest', icon: 'fa-barcode', auth: true, always: false, position: 'left'},
        {
          title: 'Statistiche',
          path: '/statistiche',
          icon: 'fa-random',
          auth: true,
          always: false,
          position: 'left',
          children: [
            {
              title: 'Spedizioni',
              path: '/statistiche/spedizioni',
              icon: 'fa-shipping-fast',
              auth: true,
              always: false,
              position: 'left'
            },
            {
              title: 'Fornitori',
              path: '/statistiche/ordiniforn',
              icon: 'fa-people-carry',
              auth: true,
              always: false,
              position: 'left'
            },
            {
              title: 'Previsioni',
              path: '/statistiche/previsioni',
              icon: 'fa-calculator',
              auth: true,
              always: false,
              position: 'left'
            },
            {
              title: 'Vendite',
              path: '/statistiche/prodottinonvenduti',
              icon: 'fa-sack-dollar',
              auth: true,
              always: false,
              position: 'left'
            },
            {
              title: 'OverStock',
              path: '/statistiche/prodotti_stack',
              icon: 'fa-cubes-stacked',
              auth: true,
              always: false,
              position: 'left'
            },
            {
              title: 'Marginalità',
              path: '/statistiche/marginalita',
              icon: 'fa-piggy-bank',
              auth: true,
              always: false,
              position: 'left'
            },
            {
              title: 'Reports',
              path: '/statistiche/reports',
              icon: 'fa-envelope',
              auth: true,
              always: false,
              position: 'left'
            },
            {
              title: 'Scadenze',
              path: '/statistiche/scadenze',
              icon: 'fa-clock',
              auth: true,
              always: false,
              position: 'left'
            },
            {
              title: 'Movimentazioni',
              path: '/statistiche/stat_movimentazioni',
              icon: 'fa-chart-line',
              auth: true,
              always: false,
              position: 'left'
            }
          ]
        },
        {
          title: 'Tools',
          path: '/tools',
          icon: 'fa-cogs',
          auth: true,
          always: false,
          position: 'left',
          children: [
            {title: 'Impostazioni', path: '/settings', icon: 'fa-wrench', auth: true, always: false, position: 'left'},
            {
              title: 'Registro Log',
              path: '/registro_log',
              icon: 'fa-info',
              auth: true,
              always: false,
              position: 'left'
            },
            {
              title: 'Prodotti Da Saldare',
              path: '/tools/prodotti_da_saldare',
              icon: 'fa-search-dollar',
              auth: true,
              always: false,
              position: 'left'
            },
            {
              title: 'Controllo prodotti pubblici',
              path: '/tools/controlla_prodotti_pubblici_archiviati',
              icon: 'fa-search-dollar',
              auth: true,
              always: false,
              position: 'left'
            },
            {
              title: 'Controllo prodotti ordini',
              path: '/ProdNoGest',
              icon: 'fa-search',
              auth: true,
              always: false,
              position: 'left'
            },
            {
              title: 'Controllo confezioni',
              path: '/ConfBlank',
              icon: 'fa-search',
              auth: true,
              always: false,
              position: 'left'
            },
            {
              title: 'Ricalcola Prodotti',
              path: '/ricalcolaprod',
              icon: 'fa-calculator',
              auth: true,
              always: false,
              position: 'left'
            }
          ]
        }
      ]
    }
  },
  props: {
    source: String
  },
  computed: {
    auth () {
      return this.$store.getters.isAuthenticated
    },
    username () {
      return this.$store.getters.getUsername
    },
    menuTitle () {
      return this.$store.getters.getPagina
    }
  },
  methods: {
    goProfilo () {
      this.$router.push('/Profilo/')
    },
    onLogout () {
      this.$store.dispatch('logout')
    },
    thereIsFooter () {
      if (this.$router.currentRoute.fullPath === '/Inventario' || this.$vuetify.breakpoint.smAndDown) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>

<style>


::-webkit-scrollbar {
  width: 12px;
  background-color: #F5F5F5;
}

::-webkit-scrollbar-track {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  border: 1px solid #ccc;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: linear-gradient(left, #fff, #e4e4e4);
  border: 1px solid #aaa;
}

::-webkit-scrollbar-thumb:hover {
  background: #fff;
}

::-webkit-scrollbar-thumb:active {
  background: linear-gradient(left, #22ADD4, #1E98BA);
}

.dg-content {
  font-weight: 400 !important;
  letter-spacing: normal !important;
  font-family: Roboto, sans-serif !important;
  padding: 1em 0em !important;
}

.dg-btn--ok {
  background-color: #FF9800 !important;
  border-color: #FF9800 !important;
  color: #FFFFFF !important;
  font-family: Roboto, sans-serif !important;
  font-weight: 400 !important;
}

.dg-btn--cancel {
  background-color: #FFFFFF !important;
  border-color: #FF9800 !important;
  color: #FF9800 !important;
  font-family: Roboto, sans-serif !important;
  font-weight: 400 !important;
}

.drawer-box {
  padding: 0px !important;
}

.drawer-title-box {
  padding: 0px !important;
}

.DomContainer {
  max-width: 1250px !important;
  padding: 10px;
}

.display-1.custom,
.display-2.custom {
  font-size: 20px !important;
  line-height: 24px !important;
  font-weight: 700 !important;
}

.v-btn__content {
}
</style>



// WEBPACK FOOTER //
// src/App.vue